import {useState} from "react";
import {useDispatch} from 'react-redux';
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

import {formatProviderName} from "../../helpers/providers";
import {useGetHighlightsQuery} from '../../redux/services/providerHighlightApi';
import {useCreateImpersonationMutation}  from "../../redux/services/impersonationApi";
import { useGetProvidersQuery } from "../../redux/services/providerApi";
import {startImpersonation} from '../../redux/reducers/auth';
import CustomSelect from "../common/CustomSelect";

const handleImpersonate = ({create, impersonate, navigate}) => async (e, {userId}) => {
  const response = await create({userId});
  if (response?.data?.access) {
    impersonate({
      accessToken: response.data.access,
      refreshToken: response.data.refresh,
      user: response.data.user,
      email: response.data.email,
      deviceToken: response.data.device_token,
      deviceExp: response.data.expires_on,
    });
    navigate('/providers');
  }
};

const ImpersonateProviderRoleForm = ({onSubmit}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const [providerFilters, setProviderFilters] = useState({});
  const [create] = useCreateImpersonationMutation();
  const impersonate = params => dispatch(startImpersonation(params));
  const providerQuery = useGetProvidersQuery({id: selectedProviderId}, {skip: !selectedProviderId});
  const searchQuery = useGetProvidersQuery({}, {skip: false});
  const highlightsQuery = useGetHighlightsQuery(null, {skip: false});
  console.log('PROVIDER_QUERY', searchQuery);
  const provider = (providerQuery?.data || []).find(p => p.id === selectedProviderId);
  const userId = provider?.user_id || provider?.user?.id;
  return (
    <Stack spacing={2}>
      <Typography variant="h2">Impersonate Provider</Typography>
      <CustomSelect
        label='Select Provider' 
        disabled={searchQuery.isLoading}
        options={(searchQuery?.data || []).map(p => ({
          label: formatProviderName(p), 
          value: p.id
        }))}
        onChange={e => setSelectedProviderId(e.target.value)}
      />
      <Stack>
        <Button
          variant='contained'
          disabled={!userId}
          onClick={e => handleImpersonate({create, impersonate, navigate})(e, {userId})}
        >
          Impersonate Provider
        </Button>
      </Stack>
    </Stack>
    );
  };

export default ImpersonateProviderRoleForm;